import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { List, ListItem, ListItemText, ListSubheader, withStyles } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import classNames from "classnames";
import { MdLabel } from "react-icons/md";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const styles = theme => ({
    root: {
        width: "100%",
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: 8,
    },
    item: {
        height: 40,
        borderRadius: "0 20px 20px 0",
        paddingRight: 12,
        "&.active": {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText + "!important",
            transition: "border-radius .15s cubic-bezier(0.4,0.0,0.2,1)",
            "& .list-item-text-primary": {
                color: "inherit"
            },
            "& .list-item-icon": {
                color: "inherit"
            }
        },
        "&.square, &.active.square": {
            width: "100%",
            borderRadius: "0"
        },
        "& .list-item-icon": "folder",
        "& .list-item-text": {},
        color: theme.palette.text.primary,
        textDecoration: "none!important"
    }
});

class EmpresaPessoaSidebar extends XAPPComponent {

    state = { tags: "" };

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(prevState.tags, this.state.tags)) {
            this.props.setcondicoes(this.state);
        }

        if (this.state.tags !== "" && !_.isEqual(prevProps.Pessoas?.data, this.props.Pessoas?.data)) {
            this.setState({ tags: "" });
        }
    }

    setConditions = (_AName, _AValue) => {
        var obj = this.state[_AName];
        var response = "";
        if (obj.length > 0 && this.IsExist(_AName, _AValue)) {
            obj.split(",").forEach(item => {
                if (item !== _AValue.toString()) {
                    response = response.length > 0 ? response + "," + item : item.toString();
                }
            });
            this.setState({ [_AName]: response });
        }
        else {
            response = obj.length > 0 ? obj + "," + _AValue : _AValue.toString();
            this.setState({ [_AName]: response });
        }
    };

    IsExist = (_AName, _AValue) => {
        var AExist = false;
        var obj = this.state[_AName];
        if (obj.length > 0) {
            obj.split(",").forEach(item => {
                if (item === _AValue.toString()) {
                    AExist = true;
                }
            });
        }
        return AExist;
    };

    getArray = () => {
        const { Pessoas } = this.props;
        if (!_.isUndefined(Pessoas.data) && !_.isNull(Pessoas.data) && Pessoas.data.length > 0) {
            return Pessoas.data;
        }
        return [];
    };

    getTagsPessoas = () => {
        var AData = [];
        var ACount = {};
        var AArray = this.getArray();
        const { TagsPessoa } = this.props;

        AArray.forEach(item => {
            if (!_.isNull(item.tags) && item.tags.length > 0) {
                item.tags.split(",").forEach(id => {
                    if (_.findIndex(AData, { codigo: id }) === -1) {
                        var ATag = _.find(TagsPessoa, { codigo: id });
                        if (!_.isUndefined(ATag) && !_.isNull(ATag) && _.findIndex(AData, { codigo: id }) === -1) {
                            AData.push(ATag);
                        }
                    }
                });
            }
        });

        AData.forEach(item => {
            ACount[item.codigo] = _.filter(AArray, x => (!_.isNull(x.tags) && x.tags.includes(item.codigo))).length;
        });

        return { data: AData, count: ACount };
    };

    render() {
        const { classes, TagsPessoa = null } = this.props;
        const ATags = this.getTagsPessoas();
        return (
            <React.Fragment>
                <FuseAnimate animation="transition.slideUpIn" delay={400}>
                    <div className="flex-auto border-l-1 border-solid">
                        {ATags.data.length > 0 &&
                            <List>
                                <ListSubheader className="pr-24 pl-12" disableSticky>Tags</ListSubheader>
                                {ATags.data.map((tag) => (
                                    <ListItem
                                        button
                                        key={"ListItemTag_" + tag.codigo}
                                        className={classNames(classes.item, "list-item", "list-item-icon", this.IsExist("tags", tag.codigo) && "active")}
                                        onClick={() => {
                                            this.setConditions("tags", tag.codigo);
                                        }}
                                    >
                                        <MdLabel className="list-item-icon text-20" style={{ color: tag.cor }}
                                            color="action" />
                                        <ListItemText primary={(tag.tagnome.length < 14 ? tag.tagnome : tag.tagnome.substring(0, 14) + ".") + " [ " + ATags.count[tag.codigo] + " ] "} disableTypography={true} />
                                    </ListItem>
                                ))}
                            </List>
                        }
                    </div>
                </FuseAnimate>
            </React.Fragment>
        );
    }
}

function mapStateToProps({ Pessoa }) {
    return {
        Pessoas: Pessoa.EmpresaPessoaReducer,
        TagsPessoa: Pessoa.TagFuncionalidadeReducer["pessoa"],
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps)(EmpresaPessoaSidebar)));
